require('./optionGroupTextInput.i18n.json');
require('./optionGroupTextInput.tpl.html');
require('./optionGroupTextInputController.js');

const OptionGroupTextInputComponent = {
    templateUrl: '/configuration/formEditor/content/form/componentSettings/optionGroup/optionGroupTextInput/optionGroupTextInput.tpl.html',
    controller: 'optionGroupTextInputController',
    bindings: {
        selectedField: '<',
        selectedFieldStructure: '<',
        name: '<',
        label: '<',
        inputType: '<',
        enableNumberSpinner: '<',
        inputLimit: '<',
        value: '<',
        trim: '<',
        isDisabled: '<'
    }
};

angular.module('ums.configuration')
    .component('uiOptionGroupTextInput', OptionGroupTextInputComponent);
